








































































































import { Component, Mixins } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import { Sync } from '@/interfaces/Sync'
import axios from 'axios'
import SnackbarService from '@/services/snackbar-service'
import moment from 'moment-timezone'
import CowService from '@/services/cow-service'

@Component({
  components: {},
})
export default class SyncsView extends Mixins(
  DexieService,
  SnackbarService,
  CowService
) {
  syncs: Sync[] = []

  moment: any

  search = ''
  axios: any

  confirmDeleteSyncDialogIsOpen = false
  itemToDelete: any

  headers = [
    { text: 'Action', value: 'action' },
    { text: 'Numero de vaca', value: 'number' },
    { text: 'Finca', value: 'farm_id' },
    { text: 'Tiempo', value: 'timestamp' },
    { text: 'Mensage', value: 'message', sortable: false },
    { text: 'Methodo', value: 'method' },
    { text: 'Url', value: 'url' },
    { text: 'Payload', value: 'payload' },
    { text: '', value: 'synced', sortable: false },
  ]

  created() {
    this.axios = axios
    this.moment = moment
    this.$store.state.loading = true
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.$store.state.navbarText = 'Syncronizar data'
    this.getSyncs()
  }

  getSyncs() {
    this.$db.syncs.toArray().then((syncs: Sync[]) => {
      syncs.forEach((sync: Sync) => {
        if (!sync.syncError) {
          sync.synced = false
          sync.syncError = false
          sync.syncing = false
        }
      })
      this.syncs = syncs
      this.$store.state.loading = false
    })
  }

  async syncData() {
    if (navigator.onLine) {
      this.$store.state.loading = true
      const idsToChange = {}
      for await (const sync of this.syncs) {
        sync.syncing = true
        try {
          if (sync.method === 'patch' && sync.url.startsWith('cows/')) {
            const dexieCowId = sync.url.split('/').slice(-1)[0]
            const newDbId = idsToChange[dexieCowId]
            sync.url = `cows/${newDbId}`
          } else if (sync.method === 'post' && sync.url === '/cows') {
            sync.payload.id = null
          }
          const res = await this.axios({
            method: sync.method,
            url: sync.url,
            data: sync.payload,
          })
          sync.syncing = false
          sync.synced = true
          this.$db.syncs.delete(sync.id)
          // if offline_added, replace all ids with readl backend database id
          if (sync.offlineAddedId) {
            idsToChange[sync.offlineAddedId] = res.data.id
          }
        } catch (error) {
          sync.syncing = false
          sync.syncError = true
          if (error.response.data && error.response.data.detail) {
            sync.errorMessage =
              error.response.data && error.response.data.detail
          } else {
            sync.errorMessage = error
          }
        }
      }
      this.$store.state.loading = false
    } else {
      this.notify({ text: 'No connection de internet' })
    }
  }

  openDialogConfirmDelete(item: any) {
    this.itemToDelete = item
    this.confirmDeleteSyncDialogIsOpen = true
  }

  deleteSync() {
    this.$db.syncs.delete(this.itemToDelete.id)
    this.confirmDeleteSyncDialogIsOpen = false
    this.getSyncs()
  }
}
